import { Reveal } from "./Reveal";

/**
 * Shared, centered, big white section heading used inside every collapsible
 * BigTile (credit cards, products, etc). Streamlines the two tiles so
 * category headings look identical across the page.
 */
export default function GroupHeader({ title, testid }) {
  if (!title) return null;
  return (
    <Reveal className="mb-5 text-center">
      <h3 data-testid={testid} className="text-xl font-bold tracking-tight text-white sm:text-[22px]">
        {title}
      </h3>
    </Reveal>
  );
}
